









































































































































































































































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import Requester from '../../requester';
import { filterDeburr } from '../../utils/functions';
import { statusExameItems, tipoPartoStrings, statusExameStrings } from '../../utils/constants';

import { Exame } from '../../../../back/src/entity/Exame';
import { Gestacao } from '../../../../back/src/entity/Gestacao';
import { Paciente } from '../../../../back/src/entity/Paciente';
import {
  GruposResultadosExamesForm,
  ResultadoDeExameFormItem,
  TipoParto,
  StatusExame,
  ResultadoDeExameFormData,
  OpcaoStatus,
} from '../../../../back/src/types';

import Carregando from '../../components/Carregando.vue';
import Confirmar from '../../components/Confirmar.vue';
import ThePacientesResumo from '../../components/pacientes/ThePacientesResumo.vue';
import ThePacientesObservacoesAlert from '../../components/pacientes/ThePacientesObservacoesAlert.vue';
import ResultadosDeExamesGrupoForm from '../../components/resultados_de_exames/ResultadosDeExamesGrupoForm.vue';
import ResultadosDeExamesGrupoItemForm from '../../components/resultados_de_exames/ResultadosDeExamesGrupoItemForm.vue';
import ResultadosDeExamesRevisar from '../../components/resultados_de_exames/ResultadosDeExamesRevisar.vue';

export default Vue.extend({
  name: 'ResultadosDeExamesNovo',
  components: {
    Carregando,
    Confirmar,
    ThePacientesResumo,
    ThePacientesObservacoesAlert,
    ResultadosDeExamesGrupoForm,
    ResultadosDeExamesGrupoItemForm,
    ResultadosDeExamesRevisar,
  },
  data() {
    return {
      loading: {
        paciente: true,
        exames: true,
        submit: false,
      },
      revisarResultados: false,
      dinamicKey: 0,
      showGruposResultados: true,
      validFormDataExame: false,
      paciente: {} as Paciente,
      gestacao: {} as Gestacao,
      exames: [] as Exame[],
      menuDataExame: false,
      searchInput: '',
      filterGrupo: null,
      filterExame: '',
      form: {
        dataExame: '',
        gruposResultados: [] as GruposResultadosExamesForm[],
        resultadosExtras: [] as ResultadoDeExameFormItem[],
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
      },
    };
  },
  computed: {
    pacienteId(): number {
      return Number(this.$route.params.pacienteId);
    },
    gestacaoId(): number {
      return Number(this.$route.params.gestacaoId);
    },
    gruposExamesItems() {
      return _.map(
        _.orderBy(this.form.gruposResultados as GruposResultadosExamesForm[], ['grupoExameOrdem']),
        item => ({ value: item.grupoExameId, text: item.grupoExameNome }),
      );
    },
    tituloGestacao(): string {
      if (!this.gestacao) {
        return 'Sem gestação associada';
      }
      if (this.paciente.gestacao_atual && this.paciente.gestacao_atual.id === this.gestacao.id) {
        return 'Gestação atual';
      }
      const momentDataParto = moment(this.gestacao.data_parto);
      const dataParto = momentDataParto.isValid() ? momentDataParto.format('DD/MM/YYYY') : '';
      const tipoParto = _.has(tipoPartoStrings, this.gestacao.tipo_parto)
        ? ` - ${tipoPartoStrings[this.gestacao.tipo_parto]}`
        : '';
      let nomeBebes = '';
      if (this.gestacao.tipo_parto === TipoParto.N || this.gestacao.tipo_parto === TipoParto.C) {
        nomeBebes = ` - ${this.gestacao.nome1}${this.gestacao.nome2 ? ` & ${this.gestacao.nome2}` : ''}`;
      }
      return `Gestação anterior (${dataParto}${tipoParto}${nomeBebes})`;
    },
    buscaVazia(): boolean {
      if (!this.filterGrupo && this.filterExame) {
        return !this.show(this.nomesExamesConcat, this.filterExame);
      }
      return false;
    },
    nomesExamesConcat(): string {
      return _.reduce(
        this.exames as Exame[],
        (result, exame) => (`${result}${exame.nome}`),
        '',
      );
    },
    totalResultados(): number {
      return _.reduce(
        this.form.gruposResultados as GruposResultadosExamesForm[],
        (resultTotal, grupoResultados) => {
          const reduceParcial = _.reduce(
            grupoResultados.resultadosDeExamesItems as ResultadoDeExameFormItem[],
            (resultParcial, item) => (
              resultParcial + (item.resultado || item.status || item.observacoes ? 1 : 0)
            ),
            0,
          );
          return resultTotal + reduceParcial;
        },
        0,
      );
    },
    totalResultadosValidos(): number {
      return _.reduce(
        this.form.gruposResultados as GruposResultadosExamesForm[],
        (resultTotal, grupoResultados) => {
          const reduceParcial = _.reduce(
            grupoResultados.resultadosDeExamesItems as ResultadoDeExameFormItem[],
            (resultParcial, item) => {
              if (item.opcoesStatus) {
                return resultParcial + (item.resultado && item.status ? 1 : 0);
              }
              return resultParcial + (item.resultado ? 1 : 0);
            },
            0,
          );
          return resultTotal + reduceParcial;
        },
        0,
      );
    },
    totalResultadosExtras(): number {
      return this.form.resultadosExtras.length;
    },
    totalResultadosExtrasValidos(): number {
      return _.reduce(
        this.form.resultadosExtras as ResultadoDeExameFormItem[],
        (resultParcial, item) => (
          resultParcial + (item.nomeExame && item.resultado && item.status ? 1 : 0)
        ),
        0,
      );
    },
    dataExameFormatada(): string {
      if (this.form.dataExame) {
        const momentData = moment(this.form.dataExame);
        if (momentData.isValid()) {
          return momentData.format('DD/MM/YYYY');
        }
      }
      return '';
    },
    formDataExame():
      Vue & { validate: () => boolean, reset: () => void, resetValidation: () => void } {
      return this.$refs.formDataExame as Vue & {
        validate: () => boolean,
        reset: () => void,
        resetValidation: () => void
      };
    },
    confirmar(): Vue & { open: (titulo: string, mensagem: string) => boolean } {
      return this.$refs.confirmar as Vue & { open: (titulo: string, mensagem: string) => boolean };
    },
  },
  mounted() {
    this.buscaPaciente();
    this.buscaExames();
  },
  methods: {
    filterDeburr(item: any, queryText: string, itemText: string) {
      return filterDeburr(queryText, itemText);
    },
    show(haystack: string, needle: string) {
      const haystackDeburr = _.deburr(_.lowerCase(haystack));
      const needleDeburr = _.deburr(_.lowerCase(needle));
      return haystackDeburr.includes(needleDeburr);
    },
    showGrupo(grupoResultados: GruposResultadosExamesForm) {
      if (this.filterGrupo) {
        return grupoResultados.grupoExameId === this.filterGrupo;
      }
      if (this.filterExame) {
        return this.show(grupoResultados.nomesExamesConcat, this.filterExame);
      }
      return true;
    },
    atualizaItemGrupo(grupoExameId: number, formItem: ResultadoDeExameFormItem) {
      const indexGrupo = _.findIndex(
        this.form.gruposResultados as GruposResultadosExamesForm[],
        grupoResultados => (grupoResultados.grupoExameId === grupoExameId),
      );
      if (indexGrupo < 0) return;
      const indexItem = _.findIndex(
        // eslint-disable-next-line max-len
        this.form.gruposResultados[indexGrupo].resultadosDeExamesItems as ResultadoDeExameFormItem[],
        item => (item.exameId === formItem.exameId),
      );
      if (indexItem < 0) return;
      const item = this.form.gruposResultados[indexGrupo].resultadosDeExamesItems[indexItem];
      item.resultado = formItem.resultado;
      item.status = formItem.status;
      item.observacoes = formItem.observacoes;
      this.$set(this.form.gruposResultados[indexGrupo].resultadosDeExamesItems, indexItem, item);
    },
    atualizaItemExtra(formItem: ResultadoDeExameFormItem) {
      const index = _.findIndex(
        // eslint-disable-next-line max-len
        this.form.resultadosExtras as ResultadoDeExameFormItem[],
        item => (item.ordem === formItem.ordem),
      );
      if (index < 0) return;
      const item = this.form.resultadosExtras[index];
      item.nomeExame = formItem.nomeExame;
      item.resultado = formItem.resultado;
      item.status = formItem.status;
      item.observacoes = formItem.observacoes;
      this.$set(this.form.resultadosExtras, index, item);
    },
    removeItemExtra(ordem: number) {
      const index = _.findIndex(
        this.form.resultadosExtras as ResultadoDeExameFormItem[],
        item => (item.ordem === ordem),
      );
      if (index < 0) return;
      this.$delete(this.form.resultadosExtras, index);
    },
    // resultado extra
    adicionaResultadoExtra() {
      this.form.resultadosExtras.push({
        exameId: null,
        exameLabel: '',
        exameTexto: '',
        nomeExame: '',
        ordem: this.dinamicKey,
        resultado: '',
        opcoesResultados: null,
        status: null,
        opcoesStatus: [
          { value: 'Normal', text: 'Normal', color: 'success' },
          { value: 'Alterado', text: 'Alterado', color: 'error' },
        ],
        observacoes: null,
      });
      this.dinamicKey += 1;
    },
    // grupos resultados
    montaGruposResultados() {
      const gruposResultados = [] as GruposResultadosExamesForm[];
      const gruposExames = _.groupBy(
        this.exames as Exame[],
        exame => (_.get(exame, 'grupo_exame.id', 0)),
      );
      _.forEach(gruposExames, (exames, grupoExameId) => {
        const grupo = _.get(_.first(exames), 'grupo_exame', null);
        const resultadosDeExamesItems: ResultadoDeExameFormItem[] = _.map(
          _.orderBy(exames, ['ordem']) as Exame[],
          exame => ({
            exameId: exame.id || null,
            exameLabel: exame.nome,
            exameTexto: exame.texto,
            nomeExame: null,
            ordem: exame.ordem,
            resultado: '',
            opcoesResultados: exame.opcoes_resultados
              ? _.map(
                exame.opcoes_resultados as string[],
                item => ({ value: item, text: item }),
              )
              : null,
            status: null,
            opcoesStatus: exame.opcoes_status
              ? _.map(
                exame.opcoes_status as OpcaoStatus[],
                item => ({ value: item.status, text: item.status, color: item.color }),
              )
              : null,
            observacoes: null,
          }),
        );
        const nomesExamesConcat = _.reduce(
          exames as Exame[],
          (result, exame) => (`${result}${exame.nome}`),
          '',
        );
        gruposResultados.push({
          grupoExameId: grupo ? grupo.id || 0 : 0,
          grupoExameNome: grupo ? grupo.nome || '(Sem grupo)' : '(Sem grupo)',
          grupoExameOrdem: grupo ? grupo.ordem || 0 : 0,
          nomesExamesConcat,
          resultadosDeExamesItems,
        });
      });
      this.form.gruposResultados = _.orderBy(gruposResultados, ['grupoExameOrdem']);
    },
    // paciente
    async buscaPaciente() {
      this.loading.paciente = true;
      try {
        const response = await Requester.paciente.paciente(this.pacienteId);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
          this.$router.push({ name: 'PacientesIndex' });
        } else {
          this.paciente = response.data;
          if (this.gestacaoId > 0) {
            if (this.paciente.gestacao_atual
              && this.paciente.gestacao_atual === this.gestacaoId
            ) {
              this.gestacao = this.paciente.gestacao_atual;
            } else {
              this.gestacao = _.find(
                this.paciente.gestacoes as Gestacao[],
                gestacao => (gestacao.id === this.gestacaoId),
              );
            }
          } else {
            this.gestacao = null;
          }
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.paciente = false;
      }
    },
    // exames
    async buscaExames() {
      this.loading.exames = true;
      try {
        const response = await Requester.exame.exames();
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.exames = response.data;
          this.montaGruposResultados();
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.exames = false;
      }
    },
    // cancelar
    async cancelar() {
      if (await this.confirmar.open(
        'Cancelar entrada de resultados de exames?',
        'Tem certeza que deseja cancelar a entrada de dados?\nOs dados inseridos serão perdidos.',
      ) === true) {
        this.$router.push({ name: 'PacientesVer', params: { pacienteId: this.paciente.id } });
      }
    },
    // revisar
    revisar() {
      this.$root.$emit('validate-resultados-de-exames-grupo-item-form');
      if (!this.formDataExame.validate()
        || this.totalResultados !== this.totalResultadosValidos
        || this.totalResultadosExtrasValidos !== this.totalResultadosExtras
      ) {
        return;
      }
      this.revisarResultados = true;
    },
    // submit
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      if (!this.formDataExame.validate()
        || this.totalResultados !== this.totalResultadosValidos
        || this.totalResultadosExtrasValidos !== this.totalResultadosExtras
      ) {
        return;
      }
      const formData = [] as ResultadoDeExameFormData[];
      _.forEach(
        this.form.gruposResultados as GruposResultadosExamesForm[],
        (grupoResultados) => {
          _.forEach(
            grupoResultados.resultadosDeExamesItems as ResultadoDeExameFormItem[],
            (item) => {
              if ((item.opcoesStatus && item.resultado && item.status)
                || (!item.opcoesStatus && item.resultado)
              ) {
                formData.push({
                  exame_id: item.exameId,
                  nome_exame: null,
                  gestacao_id: this.gestacao ? this.gestacao.id : null,
                  paciente_id: this.paciente.id,
                  status: item.status,
                  observacoes: item.observacoes || null,
                  data_exame: moment(this.form.dataExame).isValid()
                    ? moment(this.form.dataExame).toDate()
                    : null,
                  resultado: item.resultado || null,
                });
              }
            },
          );
        },
      );
      _.forEach(
        this.form.resultadosExtras as ResultadoDeExameFormItem[],
        (item) => {
          if (item.nomeExame) {
            formData.push({
              exame_id: null,
              nome_exame: item.nomeExame,
              gestacao_id: this.gestacao ? this.gestacao.id : null,
              paciente_id: this.paciente.id,
              status: item.status,
              observacoes: item.observacoes || null,
              data_exame: moment(this.form.dataExame).isValid()
                ? moment(this.form.dataExame).toDate()
                : null,
              resultado: item.resultado || null,
            });
          }
        },
      );
      this.loading.submit = true;
      try {
        const response = await Requester.resultadoDeExame.criaResultadoExameBulk(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Dados salvos com sucesso' });
          this.$router.push({ name: 'PacientesVer', params: { pacienteId: this.paciente.id } });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.submit = false;
      }
    },
  },
});
